import { KpiUnit } from "models/financial-kpi"

// Fiscal months in column order (period 1 = September)
export const FISCAL_MONTHS = ["Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug"]

const currency = new Intl.NumberFormat("en-CA", { style: "currency", currency: "CAD", maximumFractionDigits: 0 })

export const formatKpiValue = (value: number | null | undefined, unit: KpiUnit): string => {
    if (value === null || value === undefined || Number.isNaN(value)) return "—"
    return unit === "percent" ? `${value.toLocaleString("en-CA", { maximumFractionDigits: 1 })}%` : currency.format(value)
}

export const formatPct = (value: number | null | undefined): string =>
    value === null || value === undefined ? "—" : `${Math.round(value)}%`
